var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PureComponent } from 'react';
import uniqueId from 'uniqid';
import { createPortal } from 'react-dom';
// default z-index for portal container
var DEFAULT_Z_INDEX = 0;
var RELATIVE_POSITION = 'relative';
var Portal = /** @class */ (function (_super) {
    __extends(Portal, _super);
    function Portal(props) {
        var _this = _super.call(this, props) || this;
        var rootPortalPrefix = "Portal-" + props.prefix;
        var rootPortalZIndex = "" + (_this.props.zIndex || DEFAULT_Z_INDEX);
        // lets find parent container for this prefix
        _this.portalContainer = document.getElementById(rootPortalPrefix); // that element must always be - see below
        if (!_this.portalContainer) {
            // if not found then create
            _this.portalContainer = document.createElement('div');
            _this.portalContainer.setAttribute('id', rootPortalPrefix);
            _this.portalContainer.style.zIndex = rootPortalZIndex;
            _this.portalContainer.style.position = RELATIVE_POSITION;
            _this.portalContainer.className = rootPortalPrefix;
            var body = document.body;
            body.appendChild(_this.portalContainer);
        }
        // create the children
        _this.portalElement = document.createElement('div');
        _this.portalElement.className = rootPortalPrefix + "__" + uniqueId();
        return _this;
    }
    Portal.prototype.componentDidMount = function () {
        // Mount children
        this.portalContainer.appendChild(this.portalElement);
    };
    Portal.prototype.componentWillUnmount = function () {
        // remove children
        this.portalElement.remove();
    };
    Portal.prototype.render = function () {
        return createPortal(this.props.children, this.portalElement);
    };
    return Portal;
}(PureComponent));
export { Portal };
